export default {
  location: [1, 2],
  titles: {
    2: '商品列表标题',
    3: '商品列表标题',
    4: '商品列表标题'
  },
  bgColor: '#f7f8fb',
  pcBgColor: "#ffffff",
  titleColor: '#000000',
  titleFontSize: 20,
  pathlink: [],
  product: [],
  productList: [],
  pcBannerHeight: 149,
  pcBannerSizeNum: 2,
  pcBannerSpace: 10,
  pcBannerVerticalSpace: 0,
  mBannerHeight: 140,
  mBannerSizeNum: 1,
  mBannerSpace: 11,
  mBannerVerticalSpace: 0,
  productType: '0',
  recommendNum: 50,
  mHorizontalPadding: 12,
  pcHorizontalPadding: 0,
  titlePaddingTop: 8,
  titlePadingBottom: 8,
  pcTitlePaddingTop: 76,
  pcTitlePadingBottom: 6
};